<template>
  <div v-if="detail">
    <div class="section-title">用户信息</div>
    <el-descriptions :column="2" border size="small" class="detail-block">
      <el-descriptions-item label="用户UID">{{ detail.userUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="用户类型">{{ detail.userTypeName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="合伙人UID">{{ detail.topPartnerUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="当前净充值">{{ amountText(detail.currentNetRechargeUsdt) }}</el-descriptions-item>
      <el-descriptions-item label="链上成功充值折U总额">{{ amountText(detail.totalDepositUsdt) }}</el-descriptions-item>
      <el-descriptions-item label="链上成功提现折U总额">{{ amountText(detail.totalWithdrawUsdt) }}</el-descriptions-item>
      <el-descriptions-item label="阈值">{{ amountText(detail.thresholdUsdt) }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{ formatTime(detail.createTime) }}</el-descriptions-item>
      <el-descriptions-item label="发放卡券">{{ detail.couponName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="VIP等级">{{ detail.vipLevel ? `VIP${detail.vipLevel}` : '--' }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: 'VipRechargeTrialCardApprovalDetailBlock',
  props: {
    detail: Object,
  },
  methods: {
    amountText(value) {
      if (value === null || value === undefined || value === '') return '--';
      const text = String(value);
      return text.includes('.') ? text.replace(/\.?0+$/, '') : text;
    },
    formatTime(value) {
      if (!value) return '--';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '--';
      const p = (x) => String(x).padStart(2, '0');
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
};
</script>

<style scoped>
.section-title {
  margin: 14px 0 10px;
  font-weight: 600;
  color: #1f2f5f;
}
.detail-block {
  margin-bottom: 12px;
}
</style>
